export const applyOptimisticUpdate = async (
  patchResult: { undo: () => void },
  queryFulfilled: Promise<unknown>
) => {
  try {
    await queryFulfilled;
  } catch {
    patchResult.undo();
  }
};
